import { memo, SVGProps } from 'react';

const RecommendationBubble = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 260 146' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.99515 0C4.47498 0 0 4.47497 0 9.99514V112.445C0 117.966 4.47499 122.441 9.99515 122.441H185.747L248.984 145.635C250.065 146.031 251.062 144.879 250.513 143.866L238.898 122.441H249.879C255.399 122.441 259.874 117.966 259.874 112.445V9.99515C259.874 4.47498 255.399 0 249.879 0H9.99515Z'
      fill='#A782E9'
    />
  </svg>
);

const Memo = memo(RecommendationBubble);
export { Memo as RecommendationBubble };
